import { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import SvgIcon from "../../../../parts/SvgIcon";
import {
  integrationItemLabels,
  integrationItems,
} from "../data/getting-started";

const id = "modal-integrate-your-app";
const form = "integrate-your-app";

const IntegrationItem = ({ item, checked, onChange }) => (
  <div className="flex justify-between items-center rounded-(--border-radius-md) bg-(--white-05) p-3 mt-2">
    <label htmlFor={item} className="mb-0! opacity-100! text-md!">
      {integrationItemLabels[item]}
    </label>
    <input
      type="checkbox"
      role="switch"
      className="integration-checkbox"
      name={item}
      checked={checked}
      onChange={onChange}
    />
  </div>
);

const IntegrateYourApp = ({ workflow }) => {
  const { t } = useTranslation(["coaching-portal", "common"]);
  const items = workflow.options.integrations?.items ?? [];
  const [checkedItems, setCheckedItems] = useState(
    integrationItems.reduce((acc, item) => {
      acc[item] = items.includes(item);
      return acc;
    }, {})
  );
  const allSelected = Object.values(checkedItems).every(Boolean);

  const handleCheckboxChange = (item) => {
    setCheckedItems((prev) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };

  const handleMasterCheckboxChange = () => {
    const newCheckedState = !allSelected;
    setCheckedItems(
      integrationItems.reduce((acc, item) => {
        acc[item] = newCheckedState;
        return acc;
      }, {})
    );
  };

  return (
    <form
      action="/actions/getting-started/integrations"
      method="POST"
      id={form}
    >
      <input type="hidden" name="option" value="integrations" />
      <input type="hidden" name="workflow" value={workflow._id} />

      <Modal
        name={id}
        key={id}
        title={t("integrateYourApp.title")}
        className="getting-started-video narrow"
      >
        <div className="body">
          <p className="p5 pb-2">
            {t("integrateYourApp.description")}
          </p>

          {integrationItems.map((item) => (
            <IntegrationItem
              key={item}
              item={item}
              checked={checkedItems[item]}
              onChange={() => handleCheckboxChange(item)}
            />
          ))}

          <div className="flex items-center mt-4">
            <SvgIcon
              src={
                allSelected
                  ? "/img/new-icons/checked-square.svg"
                  : "/img/new-icons/unchecked-square.svg"
              }
              onClickFn={handleMasterCheckboxChange}
              noFilterOnLight={allSelected}
            />
            <label className="ml-2 mb-0!">{t("integrateYourApp.collectAllData")}</label>
          </div>
        </div>

        <footer className="foot">
          <button data-button-type="primary" type="submit">
            {t("common:save")}
          </button>
        </footer>
      </Modal>
    </form>
  );
};

export default IntegrateYourApp;
